import { signal } from "@preact/signals-react";
export class PreviewMoreActionsBlocState {
  appName = signal("");
  appDescription = signal("");
}

export class PreviewMoreActionsBloc {
  constructor(public state: PreviewMoreActionsBlocState) {}

  onTitleChange(e: React.ChangeEvent<HTMLInputElement>) {
    this.state.appName.value = e.target.value;
  }

  onPlaceholderChange(e: React.ChangeEvent<HTMLInputElement>) {
    this.state.appDescription.value = e.target.value;
  }

  setInit(data: PreviewApp.PreviewAppV2FieldType | undefined) {
    this.state.appName.value = data?.appName || "";
    this.state.appDescription.value = data?.appDescription || "";
  }
}
